import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-online-user',
  templateUrl: './online-user.component.html',
  styleUrls: ['./online-user.component.css']
})
export class OnlineUserComponent implements OnInit {

  constructor( public loginService:LoginService) { }
  // public AddModal= false;
  public online;
  public msgReceiver;
  public showpro=false;
  public myName ;
  public phone = "";
  public profile;
  public chat;
  public myProfile;
  ngOnInit(): void {
    // this.profile = this.loginService.onlineUser();
    this.myName = this.loginService.getWorker();
    this.loginService.showpro.subscribe(data=> this.showpro=data)
    this.msgReceiver = JSON.parse(localStorage.getItem('receiver')).userName
    console.log(this.msgReceiver);
    this.online=this.loginService.onlineUser();
    console.log(this.online)
    this.loginService.reci.subscribe(data=>
    this.msgReceiver=data)

// profile
    if(this.online.userName == this.myName.userName){
      let myProfile = {name:this.myName.Name, userName:this.myName.userName, mobile:this.myName.mobile, email:this.myName.email, img:this.myName.picture}
      console.log(myProfile)
      this.myProfile=myProfile
      // localStorage.setItem('Details', JSON.stringify(myProfile))
    }
      
  }

  openNav() {
    document.getElementById("mySidenav").style.width = "300px";
}

   closeNav() {
    document.getElementById("mySidenav").style.width = "0";
  }

  
}
